<template>
  <div class="cart-list-line-item columns is-gapless is-mobile">
    <div class="column is-one-third">
      <slot :src="imgSrc" :alt="`${productName} ${variantName}`" />
    </div>
    <div class="column">
      <div class="details-container">
        <div class="brand-name">{{ brandName }}</div>
        <div class="product-name">{{ productName }}</div>
        <div class="unit-price">{{ price }}</div>
        <div class="quantity">
          <span class="label">{{ quantityLabel }}</span>
          <span class="value">{{ quantityValue }}</span>
        </div>
        <template v-if="variantName">
          <span class="is-separator">|</span>
          <span class="variant-name">{{ variantName }}</span>
        </template>
      </div>
      <div class="remove-item">
        <Button
          :label="removeButtonLabel"
          type="btn-clear"
          size="btn-sm"
          class="btn-link"
          @click.stop="$emit('remove', id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@sephora-asia/core-button/Button.vue'
export default {
  name: 'CartListLineItem',
  components: {
    Button
  },
  props: {
    /** line item ID */
    id: {
      type: [String, Number],
      required: true
    },
    /** product/variant image URL  */
    imgSrc: {
      type: String,
      required: true
    },
    /** brand name of the product */
    brandName: {
      type: String,
      required: true
    },
    /** product name */
    productName: {
      type: String,
      required: true
    },
    /** full price of the product per unit */
    unitPrice: {
      type: [String, Number],
      required: true
    },
    /** label to indicate the value next to is for quantity */
    quantityLabel: {
      type: String,
      required: true
    },
    /** number of items of the product */
    quantityValue: {
      type: [String, Number],
      required: true
    },
    /** selected variant of the product */
    variantName: {
      type: String
    },
    /** label for remove line item button */
    removeButtonLabel: {
      type: String,
      required: true
    },
    freeText: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    price() {
      return this.type === 'redeemable' || this.type === 'gwp'
        ? this.freeText
        : this.unitPrice
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-list-line-item {
  margin: 10px 10px 0px 15px;
}

.details-container {
  padding: 0 10px 0 10px;
}

.brand-name {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1em;
  text-transform: uppercase;
}

.product-name {
  line-height: 1.7em;
}

.unit-price {
  font-weight: 500;
  line-height: 1.7em;
  text-transform: capitalize;
}

.quantity {
  margin-top: 15px;
  display: inline-block;

  .label {
    margin-right: 10px;
  }
}

.is-separator {
  color: $grey-lighter;
  font-weight: 500;
  margin-left: 5px;
  margin-right: 5px;
}

.remove-item {
  text-align: right;
}
</style>
